// extracted by mini-css-extract-plugin
export var ctas = "HeadingCtas-module--ctas--3D81A";